__turbopack_context__.v({
  "card": "TravelGuideArticleCard-module__ha3VAa__card",
  "cardBody": "TravelGuideArticleCard-module__ha3VAa__cardBody",
  "cardBodyContent": "TravelGuideArticleCard-module__ha3VAa__cardBodyContent",
  "cover": "TravelGuideArticleCard-module__ha3VAa__cover",
  "cta": "TravelGuideArticleCard-module__ha3VAa__cta",
  "ctaIcon": "TravelGuideArticleCard-module__ha3VAa__ctaIcon",
  "summary": "TravelGuideArticleCard-module__ha3VAa__summary",
  "summaryWrapper": "TravelGuideArticleCard-module__ha3VAa__summaryWrapper",
  "title": "TravelGuideArticleCard-module__ha3VAa__title",
});
